import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      cursor: text;\n    "])));
  },
  selected: function selected(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      & ::selection {\n        background: ", ";\n      }\n      & ::-moz-selection {\n        background: ", ";\n      }\n    "])), t.dateInputComponentSelectedBgColor, t.dateInputComponentSelectedBgColor);
  },
  selectedFor22Themes: function selectedFor22Themes(t) {
    var getSelection = function getSelection(background, color) {
      return (background || color) && "& ::selection {\n      background: " + background + ";\n      color: " + color + ";\n    }";
    };

    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      cursor: text;\n\n      ", "\n    "])), getSelection(t.dateInputComponentSelectedBgColor, t.dateInputComponentSelectedTextColor));
  },
  mask: function mask(t) {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n    "])), t.dateInputMaskColor);
  },
  delimiterFilled: function delimiterFilled() {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      color: inherit;\n    "])));
  }
});